export default "https://cdn-static.gokick.com/assets/81b7a47639310ad105c767144326fc68b25cbb5d/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";